// https://redux.js.org/usage/usage-with-typescript#type-checking-middleware
// @ts-nocheck
import { Middleware } from 'redux';
import { EventSourcePolyfill } from 'event-source-polyfill';
import {
  startCohortStream,
  stopCohortStream,
  streamConnected,
  streamError,
  streamDisconnected,
  dynamoUpdateReceived,
} from '../create-cohort';
import { configuration } from 'src/configuration';
import { selectAuthToken } from '../selectors';

const BASE_URL = `${configuration.accountApiUrl}/sse/dynamodb-stream`;

export const dynamoStreamMiddleware: Middleware<{}> = (store) => {
  let es: EventSourcePolyfill | null = null;

  return (next) => (action) => {
    if (startCohortStream.match(action)) {
      const { pk, sk, eventTypes } = action.payload;
      const token = selectAuthToken(store.getState());
      const params = new URLSearchParams();
      if (pk != null) params.set('pk', pk);
      if (sk != null) params.set('sk', sk);
      if (eventTypes != null) params.set('eventTypes', eventTypes);

      const url = params.toString().length > 0 ? `${BASE_URL}?${params.toString()}` : BASE_URL;

      es = new EventSourcePolyfill(url, { headers: { Authorization: `Bearer ${token}` } });

      es.onopen = () => store.dispatch(streamConnected());
      es.onmessage = (e) => {
        try {
          const { content } = JSON.parse(e.data);
          const update = JSON.parse(content);
          store.dispatch(dynamoUpdateReceived(update));
        } catch (err) {
          console.error(err);
        }
      };
      es.onerror = () => store.dispatch(streamError(new Error('SSE error')));
    }

    if (stopCohortStream.match(action) || action.type === 'createCohort/cohortPageExited') {
      if (es) {
        es.close();
        store.dispatch(streamDisconnected());
        es = null;
      }
    }

    return next(action);
  };
};
